import { CategoryIcon } from '@modules/common/components/CategoryIcon';
import { Box, Stack, Typography } from '@mui/material';
import { Category } from '@modules/common/types';
import { capitalize } from 'lodash';
import { useEffect, useState } from 'react';
import { useMeasure } from 'react-use';
import { FeedbackLabel } from 'v2/core/entities/feedback';
import { FeedbackLabelListProps } from '../FeedbackLabelList/FeedbackLabelList';
import { getMaxDisplayedLabelsCount } from '../utils';

interface FeedbackCategoryListViewProps {
  feedbackLabels: FeedbackLabel[];
  selectedLabels: FeedbackLabel[];
  shouldSortBySelection?: boolean;
  category: Category;
  renderFeedbackLabelList: (
    props?: Partial<FeedbackLabelListProps>,
  ) => JSX.Element;
  onFeedbackCardLabelClick?: (selectedLabels: FeedbackLabel[]) => void;
}

export const FeedbackCategoryListView = ({
  feedbackLabels,
  selectedLabels,
  renderFeedbackLabelList,
  onFeedbackCardLabelClick,
  category,
  shouldSortBySelection = false,
}: FeedbackCategoryListViewProps) => {
  const [labelsContainerRef, { width: availableWidth }] =
    useMeasure<HTMLDivElement>();
  const [labelsTruncationLength, setLabelsTruncationLength] = useState<
    number | undefined
  >(undefined);

  useEffect(() => {
    const maxLabelsToDisplay = getMaxDisplayedLabelsCount(
      availableWidth,
      feedbackLabels,
    );
    setLabelsTruncationLength(maxLabelsToDisplay);
  }, [availableWidth, feedbackLabels, selectedLabels, shouldSortBySelection]);

  return (
    <>
      <Box
        sx={{
          alignSelf: 'center',
        }}
      >
        <Stack alignItems="center" flex={1} direction="row" spacing={0.5}>
          <CategoryIcon category={category} size={14} />
          <Typography variant="body2">{capitalize(category)}</Typography>
        </Stack>
      </Box>
      <Box
        sx={{
          alignSelf: 'center',
        }}
      >
        <Stack ref={labelsContainerRef} flex={20} direction="row" spacing={1}>
          {renderFeedbackLabelList({
            shouldTruncateLabels: true,
            onFeedbackCardLabelClick,
            truncationLength: labelsTruncationLength,
          })}
        </Stack>
      </Box>
    </>
  );
};
